import React, { useMemo, useState } from 'react';
import { LuMapPin, LuInbox, LuCalendarClock } from 'react-icons/lu';
import BusquedaBar from '../ui/BusquedaBar';
import { coincideTodo, normalizar } from '../../utils/busqueda';

// Buscador del mapa (12-oct-2026): por nombre del cliente o del lugar, dirección, N/S de un equipo
// o número de pedido, en todo lo que hay en el mapa (no solo en la vista abierta). Al elegir un
// resultado el mapa pasa a la vista que corresponde y lo muestra (los lugares, en Pendientes).
const ICONO = { vender: LuMapPin, pendientes: LuInbox, agenda: LuCalendarClock };
const QUE = { vender: 'Lugar', pendientes: 'Pedido', agenda: 'Visita' };

export default function BuscadorMapa({ data, onElegir }) {
    const [q, setQ] = useState('');
    const resultados = useMemo(() => {
        if (!data || normalizar(q).trim().length < 2) return [];
        const items = [
            ...data.clientes.map(c => ({ p: c, vista: 'vender', texto: `${c.cliente} ${c.sede || ''} ${c.direccion || ''} ${(c.series || []).join(' ')}` })),
            ...data.pedidos.map(p => ({ p, vista: 'pendientes', texto: `${p.codigo || ''} ${p.cliente || ''} ${p.lugar || ''} ${p.direccion || ''} #${p.pedidoId} ${p.pedidoId}` })),
            ...data.visitas.map(v => ({ p: v, vista: 'agenda', texto: `${v.cliente || ''} ${v.titulo || ''} ${v.direccion || ''}` })),
        ];
        return items.filter(x => coincideTodo(x.texto, q)).slice(0, 8);
    }, [data, q]);

    // Si encontró por N/S, mostrar cuál
    const serieQueCoincide = (p) => (p.series || []).find(s => normalizar(s).includes(normalizar(q).trim()));

    return (
        <div className="relative z-[700]">
            <BusquedaBar valor={q} onChange={setQ} placeholder="Buscar cliente, dirección o N/S…" />
            {resultados.length > 0 && (
                <div className="absolute left-0 right-0 top-full mt-1 rounded-2xl bg-card shadow-xl border border-black/[0.08] dark:border-white/[0.08] overflow-hidden">
                    {resultados.map(({ p, vista }) => {
                        const Icono = ICONO[vista];
                        const ns = vista === 'vender' && serieQueCoincide(p);
                        return (
                            <button key={`${vista}-${p.id}`} type="button" onClick={() => { setQ(''); onElegir(p, vista); }}
                                className="w-full px-3.5 py-2.5 flex items-center gap-3 text-left border-b last:border-b-0 border-black/[0.05] dark:border-white/[0.05] active:bg-chip">
                                <Icono size={16} className="text-muted shrink-0" />
                                <span className="flex-1 min-w-0">
                                    <span className="block text-body font-black text-ink truncate">
                                        {[p.cliente, p.sede && p.sede !== p.cliente ? p.sede : p.lugar].filter(Boolean).join(' · ') || p.direccion}
                                    </span>
                                    <span className="block text-caption text-muted truncate">
                                        {QUE[vista]}{vista === 'pendientes' ? ` #${p.pedidoId}` : ''}{ns ? ` · N/S ${ns}` : ''} · {p.lat == null ? 'sin ubicar · ' : ''}{p.direccion || 'sin dirección'}
                                    </span>
                                </span>
                            </button>
                        );
                    })}
                </div>
            )}
            {q.trim().length >= 2 && resultados.length === 0 && (
                <p className="absolute left-0 right-0 top-full mt-1 px-3.5 py-2.5 rounded-2xl bg-card shadow-xl text-caption text-muted">
                    No hay nada en el mapa con "{q.trim()}".
                </p>
            )}
        </div>
    );
}
